// Loading FOUC
$(window).on('load', function () {
  setTimeout(function () {
    $("html").toggleClass("no-javascript js");
  }, 50);
});
